// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"281":"28017f19","307":"efd16a6d","674":"ffa9d12a","708":"d4927e84","974":"7186e953"}[chunkId] + ".js";
};